import { useAuth } from "react-oidc-context";
import { createBrowserRouter, RouterProvider, Navigate, } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import MetricsPage from "./pages/Metrics";
import RootLayout from "./pages/Root";
import ComponentsPage from "./pages/Components";
import LibraryPage from "./pages/Library";
import IncorrectUrl from "./components/IncorrectUrl";
import LoginRedirection from "./components/LoginRedirection";
import LoadingPage from "./pages/Loading";


const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <IncorrectUrl />,
    children: [
      {
        path: '/',
        element: <Navigate to='/metrics' />,
      },
      {
        path: "/metrics",
        children: [
          {
            index: true,
            element: <MetricsPage />,
          },
        ],
      },
      {
        path: "/components",
        children: [
          {
            element: <ComponentsPage />,
          },
        ],
      },
      {
        path: "/library",
        children: [
          {
            element: <LibraryPage />,
          },
        ],
      },
    ],
  },
]);

export default function App() {
  const auth = useAuth();

  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in...</div>;
    case "signoutRedirect":
      return <div>Signing you out...</div>;
  }

  if (auth.isLoading) {
    return <LoadingPage/>
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
      window.history.replaceState({}, document.title, window.location.pathname);
    return (
      <RouterProvider router={router}>
        <Navbar />
      </RouterProvider>
    );
  }

return (
  <LoginRedirection/>
);
}
